import { createGlobalStyle } from "styled-components";

// import { color, font, mixin } from '../shared/utils/styles';

export default createGlobalStyle`
body {
  background: #fff;
  font-size: 0.9em;
  font-family: 'Roboto', sans-serif;
  font-weight: normal;
  overflow-x: hidden;
}
img {
  border: 1px solid #ddd;
  padding: 1px;
  border-radius: 3px;
  height: auto;
  max-width: 100%;
}
a {
  text-decoration: none;
  color: black;
}
button {
  background: none;
  border: none;
  color: white;
  padding: 7px 12px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1.1em;
  cursor: pointer;
  border-radius: 3px;
}
h1 {
  font-size: 1.4em;
}
h2 {
  font-size: 1.2em;
}
h3 {
  font-size: 1.1em;
}
h4 {
  font-size: 1em;
}
h5 {
  font-size: .9em;
}
i {
  font-size: 1.5em;
}`;
